<template>
  <v-data-table
    id="materials_table"
    class="border-table"
    density="compact"
    :headers="headers"
    hide-no-data
    item-value="id"
    :items="items">
    <template
      v-for="key in extraKeys"
      v-slot:[`item.${key}`]="item">
      {{ item[extra[key]] + 1 }}
    </template>
    <template
      v-for="key in keys"
      v-slot:[key]="{ value, index }">
      <v-tooltip
        v-if="!isNaN(Number(value)) && value !== null"
        :text="value.toString()">
        <template v-slot:activator="activator">
          <span v-bind="activator.props">{{ getValue(value) }}</span>
        </template>
      </v-tooltip>
      <span v-else>{{ value }}</span>
    </template>
    <template
      #[`body.append`]
      v-if="summary">
      <tr
        class="text-uppercase font-weight-bold"
        style="font-size: smaller">
        <td
          class="text-end"
          :colspan="columnSpanSummary">
          {{ $t("actions.sum") }}
        </td>
        <td v-for="value in summary">
          <v-tooltip :text="value.toString()">
            <template v-slot:activator="activator">
              <span v-bind="activator.props">{{ getValue(value) }}</span>
            </template>
          </v-tooltip>
        </td>
      </tr>
    </template>

    <!-- Removed pagination-->
    <template #bottom />
  </v-data-table>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useTranslation } from "i18next-vue";
import { useSpaceStore } from "@/stores/spaceStore";

const spaceStore = useSpaceStore();

const { t } = useTranslation();
const variant = ref(null);

const props = defineProps({
  items: {
    type: Array,
    required: true
  },
  headers: {
    type: Array,
    required: true
  },
  summary: {
    type: Object,
    required: false
  },
  extra: {
    type: Object,
    required: false
  }
});
const extraKeys = computed(() => {
  return props.extra ? Object.keys(props.extra) : [];
});

const keys = computed(() => {
  return props.headers.map((header) =>
    extraKeys.value.includes(header.key) ? null : "item." + header.key
  );
});

const columnSpanSummary = computed(() => {
  if (!props.summary) {
    return 1;
  }

  return keys.value.length - Object.keys(props.summary).length;
});

function getValue(
  value: string,
  key: string | undefined = undefined,
  index: number | undefined = undefined
) {
  console.log(value, key, index);
  if (props.extra && props.extra[key]) {
    return [props.extra[key]];
  }

  if (isNaN(Number(value))) {
    return value;
  }

  const roundedValue = Math.round(Number(value) * 100) / 100;
  console.log(roundedValue, Number(value));

  if (Number(value) == roundedValue) {
    return roundedValue;
  }

  return roundedValue + "*";
}
</script>

<style scoped>
:deep() .v-data-table-header__content {
  font-weight: 700;
  font-size: smaller;
}

:deep() .v-table .v-table__wrapper > table > thead > tr > th:not(:last-child) {
  border-right: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}

:deep() .v-table .v-table__wrapper > table > tbody > tr > td:not(:last-child),
.v-table .v-table__wrapper > table > tbody > tr > th:not(:last-child) {
  border-right: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}
</style>
